type SalesTaxKitTrustedTypesPolicy = {
  createScript(value: string): unknown
  createScriptURL(value: string): unknown
}

declare global {
  interface Window {
    __stkTrustedTypesPolicy?: SalesTaxKitTrustedTypesPolicy
  }
}

export function trustedScriptUrl(value: string): string {
  return (window.__stkTrustedTypesPolicy?.createScriptURL(value) ?? value) as string
}

export function trustedJsonLd(value: string): string {
  return (window.__stkTrustedTypesPolicy?.createScript(value) ?? value) as string
}
